import ToggleAnimation from 'components/Animations/ToggleAnimation/ToggleAnimation';
import { windowIsAvailable } from 'frontend/utils/helpers';
import { useState } from 'react';
import styles from './SnowRobotButton.module.css';
const SnowRobotButton = () => {
  const [toggleState, setToggleState] = useState(true);
  const toggleSnow = () => {
    if (windowIsAvailable()) {
      setToggleState(!toggleState);
      document.querySelectorAll('.snow').forEach(snow => {
        snow.classList.toggle('nosnow');
      });
    }
  };
  return <div className={styles.snowButtonContainer} data-sentry-component="SnowRobotButton" data-sentry-source-file="SnowRobotButton.tsx">
      <button onClick={toggleSnow} className={styles.snowButton}>
        <span>Snöeffekt</span>
        <span className={styles.buttonLabel}>
          <ToggleAnimation className={styles.sliderButtonAnimation} selected={toggleState} data-sentry-element="ToggleAnimation" data-sentry-source-file="SnowRobotButton.tsx" />
          <span>{toggleState ? 'På' : 'Av'}</span>
        </span>
      </button>
    </div>;
};
export default SnowRobotButton;